import React, { useState } from 'react';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';
import LocationIcon from 'assets/images/location-icon.svg';
import { isMobileDevice, openLocation } from 'helpers/mapLinks';
import { BlockedActionDialog } from 'lib';

const LocationPin = ({ location, stopPropagation }) => {
  const navigationSystem = useSelector((state) => state.settings.settings?.navigationSystem);
  const samsara = navigationSystem === 'samsara' && isMobileDevice;
  const [notice, setNotice] = useState(false);

  const onClick = (e) => {
    if (stopPropagation) e.stopPropagation();
    if (location) openLocation(location, samsara, setNotice);
  };

  return (
    <>
      <img src={LocationIcon} alt="location" onClick={onClick} />
      {notice && (
        <span onClick={(e) => stopPropagation && e.stopPropagation()}>
          <BlockedActionDialog
            open
            title="Opening Google Maps"
            body="You will be redirected to Google Maps to view this location."
            onClose={() => setNotice(false)}
          />
        </span>
      )}
    </>
  );
};

LocationPin.propTypes = {
  location: propTypes.object,
  stopPropagation: propTypes.bool,
};

export default LocationPin;
